import React, { useState } from "react";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import { useScroll } from "framer-motion";

const MinutesOfMeeting = (props) => {
  const [file, setFile] = useState();
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN=""
        titleNameAR="محضر الاجتماع"
        lang={"ar"}
        titleName="محضر الاجتماع"
        child={[
          <div className="form-grid">
            <div>
              <AttachmentASFH
                fieldsName={"meetingAtachment"}
                show={true}
                disabled={props.disabled}
                clear={false}
                readOnly={false}
                id={`fileMinutes`}
                lang={"ar"}
                AttachementType="ActionAttachment"
                //   singleFile={SummaryList?.attachedResearchPaper}
                onChange={(e) => {
                  setFile(e.target.files[0]);
                  props.setFile(e.target.files[0]);
                }}
                //   showValidationMessage={errors?.file}
                //   validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
              />
            </div>
          </div>,
        ]}
      />
    </>
  );
};

export default MinutesOfMeeting;
